export const COMPETENCE_COLUMNS = 2
export const DEFAULT_COMPETENCE_VISIBLE_ITEMS = 2

export const MIN_PRICE = 0
export const MAX_PRICE = 20000
export const MIN_AGE = 18
export const MAX_AGE = 99
